export default "__VITE_PUBLIC_ASSET__425e0fdf__"